import buildClientAPI from 'views/providers/clientAPI'
import normalizeFormField from 'shared/utils/normalizeFormField'
import { HIDDEN_CLASS } from 'views/assets/scripts/consts'

export default () => {
  const { clientFockService } = buildClientAPI()
  const hasSuccess = /success/
  const CALLBACK = 'callback'
  const MESSAGE = 'message'
  const FORM = 'Form'
  const SUCCESS = 'Success'
  const ERROR = 'Error'

  const SELECTORS = {
    // product consultation callback form and notification selectors
    [CALLBACK]: {
      [FORM]: '[data-clientside-hook~="productConsultationCallbackForm"]',
      [SUCCESS]: '[data-clientside-hook~="productConsultationCallbackSuccess"]',
      [ERROR]: '[data-clientside-hook~="productConsultationCallbackError"]'
    },
    // product consultation message form and notification selectors
    [MESSAGE]: {
      [FORM]: '[data-clientside-hook~="productConsultationMessageForm"]',
      [SUCCESS]: '[data-clientside-hook~="productConsultationMessageSuccess"]',
      [ERROR]: '[data-clientside-hook~="productConsultationMessageError"]'
    }
  }

  const createElements = selectors =>
    Object.entries(selectors).reduce(
      (acc, [key, selector]) => ({
        ...acc,
        [key]: document.querySelector(selector)
      }),
      {}
    )

  const elements = {
    [CALLBACK]: createElements(SELECTORS[CALLBACK]),
    [MESSAGE]: createElements(SELECTORS[MESSAGE])
  }

  const setVisibility = (element, visible) => {
    element.classList[visible ? 'remove' : 'add'](HIDDEN_CLASS)
  }

  const collectFormValues = form =>
    [...form.elements]
      .filter(element => element.value.length)
      .reduce(
        (result, element) => ({
          ...result,
          [element.name]: normalizeFormField(element)
        }),
        {}
      )

  const showNotification = ({ response, type, formElement }) => {
    if (hasSuccess.test(response.data)) {
      setVisibility(formElement, false)
      setVisibility(elements[type][SUCCESS], true)
    } else {
      setVisibility(elements[type][ERROR], true)
    }
  }

  const onSubmit = (type, service) => async e => {
    e.preventDefault()
    const formElement = e.target

    if (!formElement.checkValidity()) {
      return
    }

    const response = await service.call(clientFockService, {
      params: collectFormValues(formElement)
    })

    showNotification({ type, response, formElement })
  }

  if (elements[MESSAGE][FORM]) {
    elements[MESSAGE][FORM].addEventListener(
      'submit',
      onSubmit(MESSAGE, clientFockService.submitProductConsultationMessageForm)
    )
  }

  if (elements[CALLBACK][FORM]) {
    elements[CALLBACK][FORM].addEventListener(
      'submit',
      onSubmit(
        CALLBACK,
        clientFockService.submitProductConsultationCallbackForm
      )
    )
  }
}
